import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useChatRequests } from '../ChatRequestsContext';
import { isAuthenticated } from '../common';
import { useT } from '../LocaleContext';
import { setSessionItem, SESSION_KEYS } from '../utils/browserStorage';
import { RequestsBadge } from '../styles/GlobalStyles';

const IncomingRequestsBadge = () => {
  const { incomingCount } = useChatRequests();
  const navigate = useNavigate();
  const location = useLocation();
  const [authenticated, setAuthenticated] = useState(false);
  const t = useT();

  useEffect(() => {
    isAuthenticated().then(setAuthenticated);
  }, [location.pathname]);

  if (!authenticated || incomingCount === 0) {
    return null;
  }

  const handleClick = () => {
    setSessionItem(SESSION_KEYS.openIncomingRequests, '1');
    if (location.pathname.startsWith('/chats')) {
      window.dispatchEvent(new CustomEvent('openIncomingRequests'));
    } else {
      navigate('/chats');
    }
  };

  const label = incomingCount === 1
    ? t('system.requestOne')
    : t('system.requestMany', { count: incomingCount });

  return (
    <RequestsBadge type="button" onClick={handleClick} title={t('sidebar.chatInvites')}>
      {label}
    </RequestsBadge>
  );
};

export default IncomingRequestsBadge;
